import { render, staticRenderFns } from "./variableCard.vue?vue&type=template&id=3f64a24b&"
import script from "./variableCard.vue?vue&type=script&lang=js&"
export * from "./variableCard.vue?vue&type=script&lang=js&"
import style0 from "./variableCard.vue?vue&type=style&index=0&id=3f64a24b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports